export default __webpack_public_path__ + "static/invoice-payments-merchant-acquiring-solution-e980cc18a039e8db32bf64477c975d9d.png";